import React, { Component } from "react";
import PropTypes from "prop-types";
import { translate, Trans } from "react-i18next";

import Wrapper from "components/Wrapper";
import Title from "components/Title";
import Label from "components/Label";
import Input from "components/Input";
import Select from "components/Select";
import Option from "components/Option";

import style from "./style.css";

@translate()
export default class UserHardware extends Component {
  availableLocations = [
    "",
    "Desktop",
    "TV room",
    "Living room",
    "Technical room",
    "Kitchen",
    "Bedroom",
    "Other",
    "Garage street level",
  ];

  render() {
    let selectedLocation = this.props.location;
    if (this.availableLocations.indexOf(selectedLocation) === -1) {
      selectedLocation = "";
    }
    return (
      <Wrapper>
        <Title rootClassname={style.hardwareTitle}>{(this.props.type === "extra" ? "Extra" : "Main")} {(this.props.reference === 'tv_streamer' ? 'TV Streamer' : 'STB')}<span>Status:&nbsp;{this.props.status}</span></Title>
        <Label rootClassname={style.hardwareLabels}><Trans>_HARDWARE_INDEX_SERIAL_NUMBER</Trans></Label>
        <Input rootClassname={style.hardwareFields} type="text" value={this.props.serial} disabled={true} onChange={this.props.onChange} />
        <br />
        <Label rootClassname={style.hardwareLabels}><Trans>_HARDWARE_INDEX_DEVICE_LOCATION</Trans></Label>
        <Select rootClassname={style.hardwareFields} selectedValue={selectedLocation} name={this.props.serial} onChange={this.props.onChange}>
          {this.availableLocations.map((value, index) => {
            return <Option key={index} value={value}><Trans>{value}</Trans></Option>
          })}
        </Select>
      </Wrapper>
    );
  }
}

UserHardware.propTypes = {
  type: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
  serial: PropTypes.string.isRequired,
  location: PropTypes.string,
  onChange: PropTypes.func,
  reference: PropTypes.string
};

UserHardware.defaultProps = {
  location: "",
  onChange: function() {},
};



// WEBPACK FOOTER //
// ./src/containers/UserHardware/index.js